export const openNativeDateTimePicker = (input: HTMLInputElement | null) => {
  if (!input) return;
  const target = input as HTMLInputElement & { showPicker?: () => void };
  if (typeof target.showPicker !== "function") return;
  try {
    target.showPicker();
  } catch {
    // Some browsers may block programmatic picker opening.
  }
};
